import { useEffect } from 'react';
import globalConfig from '@config';

const Sentry = import('@sentry/browser');

const useSentry = (config?: any) => {
    useEffect(() => {
        Sentry.then((sentry) => {
            sentry.init({
                dsn: globalConfig.sentry.url,
                environment: globalConfig.mode,
                debug: globalConfig.mode === 'development',
                // When running stg mode in development we don't want to send errors to Sentry
                // that's why we check if the environment is not development by NODE_ENV
                enabled: process.env.NODE_ENV !== 'development', // Disable Sentry in development
            });
            sentry.configureScope((scope) => {
                scope.setTags({
                    page_hostname: window.location.href,
                    page_language: navigator.language,
                    user_device: navigator.userAgent,
                });
                if (config) {
                    scope.setExtras({
                        widgetName: config.widget,
                        widgetOptions: config.widgetOptions,
                        brand: config.brand,
                        seriesID: config.seriesID,
                    });
                }
            });
        }).catch((err) => console.error(err));
    }, []);
};

export default useSentry;
